import { History } from 'history';
import { WithAuditDetails } from '../types';

export const FQDN_API_PATH = '/fqdn';

export const TOAST_MESSAGE_TIMEOUT = 3000;

export const GET_FQDNS = 'GET_FQDNS';
export const GET_FQDNS_PENDING = 'GET_FQDNS_PENDING';
export const GET_FQDNS_REJECTED = 'GET_FQDNS_REJECTED';
export const GET_FQDNS_FULFILLED = 'GET_FQDNS_FULFILLED';

export const CREATE_FQDN = 'CREATE_FQDN';
export const CREATE_FQDN_PENDING = 'CREATE_FQDN_PENDING';
export const CREATE_FQDN_REJECTED = 'CREATE_FQDN_REJECTED';
export const CREATE_FQDN_FULFILLED = 'CREATE_FQDN_FULFILLED';

export const UPDATE_FQDN = 'UPDATE_FQDN';
export const UPDATE_FQDN_PENDING = 'UPDATE_FQDN_PENDING';
export const UPDATE_FQDN_REJECTED = 'UPDATE_FQDN_REJECTED';
export const UPDATE_FQDN_FULFILLED = 'UPDATE_FQDN_FULFILLED';

export const DELETE_FQDN = 'DELETE_FQDN';
export const DELETE_FQDN_PENDING = 'DELETE_FQDN_PENDING';
export const DELETE_FQDN_REJECTED = 'DELETE_FQDN_REJECTED';
export const DELETE_FQDN_FULFILLED = 'DELETE_FQDN_FULFILLED';

export const ON_SELECT_FQDN = 'ON_SELECT_FQDN';
export const ON_ENTER_FQDN_LIST_PAGE = 'ON_ENTER_FQDN_LIST_PAGE';

export enum FqdnPrivileges {
    View = 'dc_access',
    Create = 'dc_access',
    Update = 'dc_access',
    Delete = 'dc_access',
}

export interface Domain {
    id?: string,
    fId?: string,
    fsId: string,
    state?: string
    domainName: string,
}

export interface RequestParams {
    id?: string,
    deliveryFunction: string,
    body?: WithAuditDetails<Domain>,
    history?: History
}

export interface FqdnAction {
    type: string,
    payload: Domain | Domain[]
}

export interface FqdnState {
    items: Domain[]
    selectedItem?: Domain
    lastUpdatedAt?: Date
    isLoading: boolean
}
